module.exports = __webpack_public_path__ + "static/media/Screen Shot 2020-09-07 at 3.33.39 PM.b6387344.png";